function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-1058.000000, -6447.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1057.000000, 6444.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Refresh",
  transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
}, /*#__PURE__*/React.createElement("g", {
  id: "refresh-ccw",
  transform: "translate(2.000000, 4.000000)",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.81818182
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "0 0.909090909 0 6.36363636 5.45454545 6.36363636"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "20 15.4545455 20 10 14.5454545 10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7181818,5.45454545 C16.7810167,2.80619241 14.5506662,0.823834768 11.8106484,0.20387115 C9.07063066,-0.416092468 6.20414469,0.413041575 4.21818182,2.4 L0,6.36363636 M20,10 L15.7818182,13.9636364 C13.7958553,15.9505948 10.9293693,16.7797288 8.18935156,16.1597652 C5.44933379,15.5398016 3.21898331,13.557444 2.28181818,10.9090909",
  id: "Shape"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "currentColor",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
})))));

var SvgIconRefresh = function SvgIconRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Refresh.57bcd8b1.svg";
export { ForwardRef as ReactComponent };